import { useState } from 'react';
import { Monitor, Tablet, Smartphone } from 'lucide-react';
import DevLandingPublic from './DevLandingPublic';

// dev-builder-200: preview responsivo. Puramente presentacional — reusa el
// MISMO componente DevLandingPublic que consume la landing pública, para que
// "lo que ves en el editor" sea "lo que se publica".

export default function PreviewPane({ landing, development, units, company }) {
  const [viewport, setViewport] = useState('desktop');

  const viewportWidths = { desktop: '100%', tablet: '768px', mobile: '375px' };

  const tabs = [
    { key: 'desktop', label: 'Escritorio', Icon: Monitor },
    { key: 'tablet', label: 'Tablet', Icon: Tablet },
    { key: 'mobile', label: 'Móvil', Icon: Smartphone },
  ];

  return (
    <div className="flex flex-col h-full bg-white shadow-md rounded-lg overflow-hidden">
      <div className="flex border-b border-gray-200">
        {tabs.map(({ key, label, Icon }) => (
          <button
            key={key}
            onClick={() => setViewport(key)}
            className={`flex items-center gap-2 px-4 py-3 border-b-2 transition ${
              viewport === key ? 'border-blue-500 text-blue-600 font-semibold' : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            <Icon className="h-5 w-5" /><span>{label}</span>
          </button>
        ))}
      </div>

      <div className="flex-1 overflow-auto flex items-start justify-center p-4 bg-gray-100">
        <div style={{ width: viewportWidths[viewport], boxShadow: '0 0 20px rgba(0,0,0,0.1)', borderRadius: '8px', overflow: 'hidden', backgroundColor: 'white' }}>
          <DevLandingPublic landing={landing} development={development} units={units} company={company} />
        </div>
      </div>
    </div>
  );
}
